import { render, staticRenderFns } from "./GeneralMeetingCommentsModal.vue?vue&type=template&id=303d4671&"
import script from "./GeneralMeetingCommentsModal.vue?vue&type=script&lang=js&"
export * from "./GeneralMeetingCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMeetingCommentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
